import { AddToMode, FormListItem, FormStatus } from '../types';
import { FormListItemApi } from '../types/formListApi';

const mapAddToMode = (mode: string): AddToMode =>
  (mode?.toLowerCase() || '').replace(/-/g, '_') === 'member_list'
    ? 'member_list'
    : 'group';

const mapStatus = (status: string): FormStatus => {
  const normalized = status?.toLowerCase() || '';
  if (normalized === 'paused' || normalized === 'closed') {
    return normalized;
  }
  return 'published';
};

export const mapFormListApiItem = (item: FormListItemApi): FormListItem => ({
  id: item.id,
  name: item.name,
  status: mapStatus(item.status),
  addTo: {
    mode: mapAddToMode(item.add_to_mode),
    groupId: item.group?.id,
    groupName: item.group?.name
  },
  registrationCount: item.paid_count,
  viewCount: item.viewed_count,
  conversionRate: item.conversion_rate,
  lastEdited: item.updated_at,
  sourceTrackingEnabled: item.is_source_tracking_enabled,
  publicUrl: item.form_link,
  coverImageUrl: item.image_url
});

export const mapFormListApi = (items: FormListItemApi[]): FormListItem[] =>
  items.map(mapFormListApiItem);
